import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isOver"];
import { useCallback } from 'react';
import AttachmentUploadDragAndDropWrapper from '../../attachments/components/AttachmentUploadDragAndDropWrapper';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropOverlay = styled.div.withConfig({
  displayName: "SpotlightLauncherDragDropWrapper__DropOverlay"
})(["position:absolute;top:0;left:0;right:0;bottom:32px;border-radius:24px;pointer-events:none;z-index:99;transition:background-color 0.2s;", ""], ({
  $isOver
}) => $isOver && `border: 1px solid #ccc;
     background-color: rgba(45, 62, 80, 0.3);
     backdrop-filter: blur(2px);`);
const SpotlightLauncherDragDropWrapper = ({
  children,
  disabled,
  onDropFiles
}) => {
  const renderContent = useCallback(_ref => {
    let {
        isOver
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsxs("div", Object.assign({
      style: {
        position: 'relative'
      },
      "data-test-id": "spotlight-launcher-drop-zone"
    }, props, {
      children: [children, /*#__PURE__*/_jsx(DropOverlay, {
        $isOver: isOver
      })]
    }));
  }, [children]);
  return /*#__PURE__*/_jsx(AttachmentUploadDragAndDropWrapper, {
    onDropFiles: onDropFiles,
    disabled: disabled,
    ignoreDropWhenDefaultPrevented: false,
    children: renderContent
  });
};
SpotlightLauncherDragDropWrapper.displayName = 'SpotlightLauncherDragDropWrapper';
export default SpotlightLauncherDragDropWrapper;